import {
  call, put, takeEvery, all, fork, select,
} from 'redux-saga/effects';
import { api } from '../../helpers/api';
import {
  addAccessRequest,
  invitesRequest,
  invitesSuccess,
} from './actions';
import { createToastRequest } from '../toasts/actions';
import {
  refreshRequest,
} from '../auth/actions';
import { Invites } from './constants';
import history from '../../history';

const getAuth = (state) => state.auth?.auth;

export function* fetchInvites(ops) {
  const { data, callback } = ops;
  const authData = yield select(getAuth);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, '/access', 'POST', data, authData.access_token);
      if (response.ok) {
        yield put(invitesSuccess());
        if (callback) callback();
      } else if (response.status === 401) {
        yield put(refreshRequest(invitesRequest, data, callback));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

export function* addAccess(ops) {
  const { data, callback } = ops;
  const authData = yield select(getAuth);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, '/access', 'PUT', data, authData.access_token);
      if (response.ok) {
        const parsed = yield response.json();
        if (callback) callback(parsed);
      } else if (response.status === 401) {
        yield put(refreshRequest(addAccessRequest, data, callback));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

export function* deleteAccess(ops) {
  const { data, callback } = ops;
  const authData = yield select(getAuth);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, '/access', 'DELETE', data, authData.access_token);
      if (response.ok) {
        const parsed = yield response.json();
        if (callback) callback(parsed);
      } else if (response.status === 401) {
        yield put(refreshRequest(deleteAccessRequest, data, callback));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

function* invitesSaga() {
  yield takeEvery(Invites.invitesRequest, fetchInvites);
  yield takeEvery(Invites.addAccessRequest, addAccess);
  yield takeEvery(Invites.deleteAccessRequest, deleteAccess);
}

function* configSaga() {
  yield all([fork(invitesSaga)]);
}

export default configSaga;
